import styled from 'styled-components'
import { theme } from '../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  width: 100%;

  margin: 16px 0px;
`

export const Image = styled.img`
  width: 100px;
  height: 100px;

  border-radius: 50%;

  object-fit: cover;
`

export const InfoDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100px;
`

export const InfoTitle = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};
`

interface IInfoProps {
  onClick?: () => void
}

export const Info = styled.div<IInfoProps>`
  display: flex;
  align-items: center;
  gap: 6px;

  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.lightGreen};

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${theme.colors.green5};
    }
  }

  svg[data-name='arrow-right-second'] {
    width: 10px;
    height: 10px;
  }

  a {
    color: ${theme.colors.lightGreen};
  }

  a[data-class='email'] {
    text-decoration: none;
  }
`

export const TextHeader = styled.div`
  width: 100%;

  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.white};

  margin-bottom: 8px;
`

interface IConfirmButtonProps {
  invertColor?: boolean
}

export const ConfirmButton = styled.button<IConfirmButtonProps>`
  width: 100%;
  background-color: ${({ invertColor }) => (invertColor ? theme.colors.white : theme.colors.green2)};
  border-radius: ${theme.border.mediumRadius};
  padding: 24px 0px;
  border: none;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
  color: ${({ invertColor }) => (invertColor ? theme.colors.green2 : theme.colors.white)};
`

export const Content = styled.div`
  padding: 0px 16px;
  margin-top: 40px;
  margin-bottom: 16px;

  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    padding: 0px 100px;
  }
`

export const ContentDetails = styled.div`
  width: 100%;
  margin-bottom: 24px;

  display: flex;
  flex-direction: column;

  iframe {
    width: 100%;
    height: 238px;
    border-radius: ${theme.border.mediumRadius};
    margin-top: 8px;
  }
`

export const DetailTitle = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.green2};

  margin-bottom: 8px;
`

export const DetailText = styled.div`
  font-size: ${theme.font.sizes.small};
  color: ${theme.colors.gray900};
  font-weight: ${theme.font.normal};
`

export const TextContent = styled.div`
  width: 100%;
  margin-bottom: 16px;

  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray900};

  span {
    font-weight: ${theme.font.bold};
  }
`
